import { I18n } from '@calendly/i18n'

const isLimitSet = (limit) => limit !== undefined && limit !== null

export const getEventLimitsSummary = (eventLimits) => {
  const { dailyLimit, weeklyLimit, monthlyLimit } = eventLimits || {}

  if (!isLimitSet(dailyLimit) && !isLimitSet(weeklyLimit) && !isLimitSet(monthlyLimit)) {
    return I18n.t('publisher.availability.host_meeting_limits.not_set')
  }

  const limits = []
  if (isLimitSet(dailyLimit)) {
    limits.push(I18n.t('publisher.availability.host_meeting_limits.daily', { count: dailyLimit }))
  }
  if (isLimitSet(weeklyLimit)) {
    limits.push(I18n.t('publisher.availability.host_meeting_limits.weekly', { count: weeklyLimit }))
  }
  if (isLimitSet(monthlyLimit)) {
    limits.push(I18n.t('publisher.availability.host_meeting_limits.monthly', { count: monthlyLimit }))
  }

  return limits.join(', ')
}
